export default __webpack_public_path__ + "static/media/Add_Data_Access_Role.ff994a1f.png";